import { listVal } from "@paroi/data-formatters-lib";
import type { CreateTableInput } from "../domain/table";
import { fetchQuery } from "../shared/http-client";
import {
  type APITable,
  type TableColumnTypes,
  formatToTable,
  formatToTableColumnTypes,
} from "./table.formatter";

export async function createTableAPI(referenceId: number, input: CreateTableInput): Promise<void> {
  await fetchQuery(`references/${referenceId}/tables`, {
    method: "POST",
    body: JSON.stringify({
      ...input,
      schema: input.schema.map((field) => {
        return {
          ...field,
          type: field.type.includes("enum") ? "enum" : field.type,
          data_source: field.data_source ?? [],
        };
      }),
    }),
  });
}

export async function fetchTablesAPI(referenceId: number): Promise<APITable[]> {
  const res = await fetchQuery(`references/${referenceId}/tables`);
  return listVal(res.data, formatToTable);
}

export async function fetchOneTableAPI(referenceId: number, tableId: number): Promise<APITable> {
  const res = await fetchQuery(`references/${referenceId}/tables/${tableId}`);
  return formatToTable(res.data);
}

export async function deleteTableAPI(referenceId: number, tableId: number): Promise<void> {
  await fetchQuery(`references/${referenceId}/tables/${tableId}`, {
    method: "DELETE",
  });
}

export async function updateTableAPI(
  referenceId: number,
  tableId: number,
  input: CreateTableInput,
): Promise<void> {
  await fetchQuery(`references/${referenceId}/tables/${tableId}`, {
    method: "PUT",
    body: JSON.stringify({
      ...input,
      schema: input.schema.map((field) => {
        return {
          ...field,
          type: field.type.includes("enum") ? "enum" : field.type,
          data_source: field.data_source ?? [],
        };
      }),
    }),
  });
}

export async function fetchTableColumnTypesAPI(): Promise<TableColumnTypes> {
  const res = await fetchQuery("references/schema-types");
  return formatToTableColumnTypes(res.data);
}
